export const OVERLAY_OPENED = 'overlay-opened';

export const OVERLAY_CLOSED = 'overlay-closed';
